import { Box, Stack } from "@mui/material"
import ComplianceDonut from "../components/ComplianceDonut"
import ComplianceAlertBox from "../components/ComplianceAlertBox"
import ComplianceAlertMessage from "../components/ComplianceAlertMessage"
import { Compliance, ItemComplianceStatus } from "../types"

type ComplianceWrapper = {
  type: string,
  label: string,
  image: string,
  values: ItemComplianceStatus[],
  compliance: Partial<Compliance> | null,
}

const ComplianceWrapper = (props: ComplianceWrapper) => {
  const { type, label, image, values, compliance } = props

  return (
    <Stack direction="row" alignItems="center" padding={2} justifyContent="center">
      <Box data-testid={`${type}-donut-box`}>
        <ComplianceDonut
          image={image}
          label={label}
          values={values}
        />
      </Box>
      <Box className="flex">
        <ComplianceAlertBox
          data-testid="compliance-alert-box"
          compliance_status={compliance?.compliance_status ?? 4}
        />
        <ComplianceAlertMessage
          data-testid="compliance-alert-message"
          message={compliance?.message_long ?? ''}
          compliance_status={compliance?.compliance_status ?? 4}
        />
      </Box>
    </Stack>
  )
}

export default ComplianceWrapper
